import React from 'react';

import {DeletedDocuments} from './deleted-documents';
import {RecentDocuments} from './recent-documents';
import {UnpublishedDocuments} from './unpublished-documents';
import {useSidebarTabs} from '../../../../hooks/use-sidebar-tabs';
import {useHandleFindUsages} from '../../common/sidebar-search-field/hooks/use-handle-find-usages';
import {usePageLayout} from '../../../../components/layout/page-layout/use-page-layout';
import {CategoryTree} from './ontology-layout/category-tree';
import {SearchLayout} from './search-layout/search-layout';
import {useSidebarSearchProps} from '../../common/sidebar-search-field/hooks/use-sidebar-search-props';
import {useDocumentSidebarState} from '../../common/right-sidebar/hooks/use-document-sidebar-state';

interface Props {
    tabSettings: ReturnType<typeof useSidebarTabs>;
    layoutSettings: ReturnType<typeof usePageLayout>;
    searchSidebarContext: ReturnType<typeof useSidebarSearchProps>;
    findUsagesProps: ReturnType<typeof useHandleFindUsages>;
    documentId?: string;
    revisionId?: string;
    getDocumentLink: (documentId: string, nodeId?: string) => string;
    rightSidebarProps: ReturnType<typeof useDocumentSidebarState>;
}

export const EditModeDocumentsSidebar = (props: Props) => {
    switch (props.tabSettings.activityBarTab) {
        default:
        case 'recent':
            return <RecentDocuments closeSidebar={props.layoutSettings.closeSidebar} />;
        case 'search':
            return (
                <SearchLayout
                    searchSidebarContext={props.searchSidebarContext}
                    findUsagesProps={props.findUsagesProps}
                    documentId={props.documentId}
                    revisionId={props.revisionId}
                    getDocumentLink={props.getDocumentLink}
                    closeSidebar={props.layoutSettings.closeSidebar}
                    rightSidebarProps={props.rightSidebarProps}
                />
            );
        case 'unpublished':
            return <UnpublishedDocuments closeSidebar={props.layoutSettings.closeSidebar} />;
        case 'documents':
            return <CategoryTree closeSidebar={props.layoutSettings.closeSidebar} />;
        case 'bin':
            return (
                <DeletedDocuments
                    closeSidebar={props.layoutSettings.closeSidebar}
                    documentId={props.documentId}
                />
            );
    }
};
